import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { Time, formatDate } from '@angular/common';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { RoomsModel } from 'src/app/models/RoomsModel';
import { RoomsService } from 'src/app/services/RoomsService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialog } from '@angular/material/dialog';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { PatientModel } from 'src/app/models/PatientsModel';
import { ReservationModel } from 'src/app/models/ReservationModel';
import { ReservationService } from 'src/app/services/ReservationService';
import { ReportFromToComponent } from '../report-from-to/report-from-to.component';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { DoctorssearchComponent } from '../doctorssearch/doctorssearch.component';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { VacationTransService } from 'src/app/services/VacationTransService';
import { VacationTransModel } from 'src/app/models/VacationTransModel';
import { TranslateService } from '@ngx-translate/core';
import { PatientIsuranceComponent } from '../patient-isurance/patient-isurance.component';
import { PatientInsuranceService } from 'src/app/services/PatientInsuranceService';
import { PatientInsuranceModel } from 'src/app/models/PatientInsuranceModel';
import { InsuranceCompanyModel } from 'src/app/models/InsuranceCompanyModel';
import { IsuranceCopmanyService } from 'src/app/services/IsuranceCopmanyService';
import { DomSanitizer } from '@angular/platform-browser';
import { ReservationVModel } from 'src/app/models/ReservationVModel';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.css'],
})
export class BookingComponent implements OnInit {
  ReportURL0 = 'CocReports/ReservationByRoom';
  ReportURL1 = 'CocReports/ReservationByDoctor';
  ReportURL2 = 'CocReports/ReservationByPatient';

  docCode = '';
  docName = '';
  compCode = '1';
  userID = 'sa';
  ///---------- decliration of Patients ----------
  patientCode = '';
  patientFName = '';
  diagnosis = '';
  patientLName = '';
  patientFullName = '';
  birthDate = '2022-01-01';
  education = '';
  nationality = '';
  occupation = '';
  referredFrom = '';
  telHome = '';
  telBusin = '';
  telMobile = '';
  addressHome = '';
  addressBusin = '';
  email = '';
  relativeName = '';
  relativeTelHome = '';
  relativeTelBusin = '';
  relativeTelMobile = '';
  relativeAddressHome = '';
  relativeAddressBusin = '';
  userDef1 = '';
  userDef2 = '';
  userDefDate = '';
  userDefNum = '';
  dateEntry = '';
  gender = '';
  marital = '';
  noChildren = '';
  ageOldest = '';
  ageYoungest = '';
  status = '';
  cancerID = '';
  docCode1 = '';
  txtRef = '';
  pathology = '';
  menstrual = '';
  since = '';
  contraception = '';
  pregnancy = '';
  smoker = '';
  smokerType = '';
  noPacks = '';
  sSince = 0;
  mSince = '';
  drinkingAlcohol = '';
  deteRelapse = '';
  modifaiedDate = '2021-01-01';
  //---------------------Reservation Decliration-------------------------------
  patientName = '';
  resDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  resTime = formatDate(new Date(), 'HH:mm', 'en');
  resToTime = formatDate(new Date(), 'HH:mm', 'en');

  resDuration = '';
  resRoom = '';
  resRoomDesc = '1';
  resDoc = '';
  resDocName = '';
  resType = 'Treatment';
  resNotes = '';
  resStatus = '';
  roomCode = '1';
  roomName = '';
  resPhone = '';
  resDate1 = '';
  id = 0;
  resconsultant = '';
  resonline = 'On Site';

  PatientCode ='';
  consultantName ='';
  fromDate='';
  toDate='';

  wk_Exist = 'No';
  fromDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  toDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  wk_FromTime =formatDate(new Date(), 'HH:mm:ss', 'en');
  wk_ToTime = formatDate(new Date(), 'HH:mm:ss', 'en');

  war_from =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  war_to  =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  screenTitle ='';
  styleColor =[];
  roomsList: RoomsModel[] = [];
  doctorsList: DoctorsModel[] = [];
  wk_Doublication_worrning = '';

  reservationList: ReservationModel[] = [];
  reservationAllDayList: ReservationVModel[] = [];
  tsduration =0;

  ////-------------------------------------
  myimage :any;
  myimage2 = 'data:image/jpg;base64,'
  imageSrc;
  imageSource: any;
  sellersPermitFile: any;
  sellersPermitString = '';
  wk_Acc_Not = false;
  wk_Acc_Not1 = true;
  medcompany = 0;
  @Output() submitClicked = new EventEmitter<any>();

  constructor(
    public doctorsService: DoctorsService,
    public roomsService: RoomsService,
    public storage: LocalStorageService,
    public patientsSelectedData: PatientModel,
    private dialogref: MatDialog,
    public resevationService: ReservationService,
    public reservation: ReservationModel,
    public reservationSelectedData: ReservationModel,
    public DoctorsService : DoctorsService,
    public doctorSelectedData : DoctorsModel,
    public dataBankService : DataBankService,
    public VactiontrService : VacationTransService,
    public translate: TranslateService,
    public route: Router,
    public patientinsuranceservice : PatientInsuranceService,
    public insurancecopmanyserive : IsuranceCopmanyService,
      private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {

    this.retriveRoomsLookupTop();
    this.roomCode = '1';
    this.retriveRes();
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
  ///-------------- retrive reservation table -----------------
  retriveRes() {
    this.CheckVacation();
    this.reservationList = [];
    this.resevationService.getReservation(this.resDate,this.roomCode,this.storage.retrieve('stgcompCode')).subscribe((data: ReservationModel[]) => {
        for (let i = 0; i < data.length; i++) {

          this.reservationList[i] = data[i];

          this.reservationList[i].resTime =  formatDate(data[i].resTime, 'h:mm a', 'en') ;
          this.reservationList[i].resToTime =  formatDate(data[i].resToTime, 'h:mm a', 'en') ;


          this.reservationList[i].resTime1 =  formatDate(data[i].resTime1, 'HH:mm', 'en') ;
          this.reservationList[i].resToTime1 =  formatDate(data[i].resToTime1, 'HH:mm', 'en') ;

          if(data[i].resStatus == 'Now')  {this.styleColor[i] = 'red'}
          if(data[i].resStatus != 'Now')  {this.styleColor[i] = 'black'}

        }

      });
      ///this.wk_Exist = 'No';

    }

  ///------------------ Look ups ------------------------------
  CheckVacation(){
    this.VactiontrService.GetVacationTransCheck(this.docCode,this.resDate).subscribe((data: VacationTransModel) => {

      if( data.vacdays != null){
        this.war_from =  formatDate(data.vacfrom, 'yyyy-MM-dd', 'en');
        this.war_to =  formatDate(data.vacto, 'yyyy-MM-dd', 'en');

        this.MesgWarning()};
    }
    );
  }
   MesgWarning() {
      Swal({
        type: 'warning',
        title: 'Oops...',
        text: ' نأسف الطبيب غير متاح الفترة من ' + this.war_from + ' الى '+ this.war_to ,
        showConfirmButton: false,
        timer: 4000,
      });
    }
  retriveRoomsLookupTop() {
    this.roomsService
      .getRoomsLookupTop(this.compCode)
      .subscribe((data: RoomsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.roomsList[i] = data[i];
        }

      });
      this.roomCode = '1';
  }
  openDoctorDialog(){
    const dialogRef = this.dialogref.open(DoctorssearchComponent,
      {
        data: {
          dataKey: this.doctorSelectedData,
          type: '',
        },
        width : '80%'
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.docCode = result.docCode;
        this.docName = result.docName;

        this.RetriveDoctor();
        dialogSubmitSubscription.unsubscribe();
      });
  }
  OpenConsultantDialog(){
    const dialogRef = this.dialogref.open(DoctorssearchComponent,
      {
        data: {
          dataKey: this.doctorSelectedData,
          type:''
        },
        width : '80%'
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.resconsultant = result.docCode;
        this.consultantName = result.docName;

       // this.RetriveDoctor();
        dialogSubmitSubscription.unsubscribe();
      });
  }
  RetriveDoctor(){
    this.docName = '';
    this.DoctorsService.getdoctors(this.docCode,this.storage.retrieve('stgcompCode')).subscribe((data: DoctorsModel) => {
      this.docName = data.docName;
    }
    );
    this.CheckVacation();
  }
  RetriveConsultant(){
    this.consultantName = '';
    this.DoctorsService.getdoctors(this.resconsultant,this.storage.retrieve('stgcompCode')).subscribe((data: DoctorsModel) => {
      this.consultantName = data.docName;
    }
    );
  }
  //--------------------------------------Emd Look ups --------------------
  // --------------------------------- patient searching ------------------
  openDialog() {
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
      data: {
        dataKey: this.patientsSelectedData,
      },
       width: '80%',
    });
    dialogRef.afterClosed().subscribe((result) => {});

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.patientCode = result.patientCode;
        this.RetrivePatientInsurance();
        this.patientFName = result.patientFName;
        this.birthDate = result.birthDate;
        this.diagnosis = result.diagnosis;
        this.gender = result.gender;
        this.resPhone = result.telMobile;
        this.compCode = result.compCode;
        this.userID = result.userID;
        this.modifaiedDate = result.modifaiedDate;
        dialogSubmitSubscription.unsubscribe();
      });
  }
  RetrivePatient(){
    this.dataBankService
    .getPatient(this.patientCode, this.compCode)
    .subscribe((data: DatabankModel) => {
      this.patientName = data.patientFullName;
      this.patientFName = data.patientFName;

      this.status = data.status;
      this.telHome = data.telHome;
      this.resPhone = data.telMobile;
      this.gender = data.gender;
      this.email = data.email;
      this.RetrivePatientInsurance();

    });
  }
  //-------------- end patient searching -------------------
  NewData() {
    this.resDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.resTime = formatDate(new Date(), 'HH:mm', 'en');
    this.resToTime = formatDate(new Date(), 'HH:mm', 'en');

    this.patientCode = '';
    this.patientName = '';
    this.patientFName = '';
    this.resDoc = '';
    this.docCode = '';
    this.docName = '';
    this.consultantName='';
    this.resDocName = '';
    this.resType = 'Treatment';
    this.resNotes = '';
    this.resStatus = '';
    this.resPhone = '';
    this.compCode = '1';
    this.userID = '';
    this.resconsultant = '';
    this.resonline = 'On Site';

    this.modifaiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.id = 0;
    this.wk_Acc_Not = false;
    this.wk_Acc_Not1 = true;
    this.medcompany = 0;
    ///this.wk_Exist = 'No';
    this.retriveRes();
  }

  mesgDelete() {

    if (this.storage.retrieve('wk_Staff_Read') == true)
    this.MesgAuthorization();
else {
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.delReservation_Line();
        Swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
}
  }

  delReservation_Line() {
   // console.log("ID:",this.id)
    this.resevationService.delReservation_Line_1(this.id,this.storage.retrieve('stgcompCode')).subscribe((data: ReservationModel) => {
        this.patientCode = data.patientCode;
        this.patientName = data.patientName;
        this.resDoc = data.resDoc;
        this.resDocName = data.resDocName;
        this.compCode = data.compCode;
        this.userID = data.userID;
        this.resPhone = data.resPhone;
        this.modifaiedDate = data.modifiedDate;
        this.NewData();
        this.retriveRes();

        this.resTime = formatDate(new Date(), 'HH:mm', 'en');
        this.resToTime = formatDate(new Date(), 'HH:mm', 'en');
      });
      ///this.wk_Exist = 'No';

  }

  submitReservation() {

  if (this.storage.retrieve('wk_Staff_Read') == true) {
    this.MesgAuthorization();
    return;
  }
  
    // -----------------------------------------
    // 1️⃣ حذف السجل و كتابتة مرة اخرى للتأكد
    // -----------------------------------------
       this.resevationService.delReservation_Line_1(this.id,this.storage.retrieve('stgcompCode')).subscribe((data: ReservationModel) => {
        this.retriveRes();
        this.wk_Exist = 'No';



    // -----------------------------------------

      this.resevationService.getDaileyReservation(this.resDate, '', '', '', '', '', this.storage.retrieve('stgcompCode')).subscribe((data: ReservationVModel[]) => {
      const newFrom = new Date(this.resDate + 'T' + this.resTime);
      const newTo   = new Date(this.resDate + 'T' + this.resToTime);

      for (let i = 0; i < data.length; i++) {

        const existingFrom = new Date(data[i].restime);
        const existingTo   = new Date(data[i].restotime);

        // -----------------------------------------
        // 1️⃣ نفس المريض + نفس الدكتور + نفس النوع
        // -----------------------------------------
        if (
          data[i].patientcode == this.patientCode &&
          data[i].resdoc == this.docCode &&
          data[i].restype == this.resType &&
          this.wk_Exist == 'No'


        ) {
          this.wk_Doublication_worrning =

            'هذا المريض مسجل مسبقا فى نفس التاريخ مع الدكتور :<br><strong>' +
            data[i].docname + '</strong>';

            this.MesgWarningDoublication();
            this.Submit_Temp();
            return;
        }

        // -----------------------------------------
        // 2️⃣ نفس المريض + نفس النوع
        // -----------------------------------------
        if (
          data[i].patientcode == this.patientCode &&
          data[i].restype == this.resType &&
          this.wk_Exist == 'No'

        ) {
          this.wk_Doublication_worrning =
            'هذا المريض مسجل مسبقا فى نفس التاريخ ';
          this.MesgWarningDoublication();
          this.Submit_Temp();
          return;
        }

        // -----------------------------------------
        // 3️⃣ تعارض وقت لنفس الدكتور
        // -----------------------------------------
        const isOverlap =
          newFrom < existingTo && newTo > existingFrom;

        if (
          data[i].resdoc == this.docCode &&
          isOverlap &&
          this.resType != 'Treatment' &&
          this.wk_Exist == 'No'

        ) {
          this.wk_Doublication_worrning =
             'هذا التوقيت محجوز لمريض اخر:<br><strong>' +
            data[i].patientname + '</strong>';

        this.MesgWarningDoublication();
        this.Submit_Temp();
        return;
      }
        if (
          data[i].resroom == this.roomCode &&
          isOverlap &&
          this.resType == 'Treatment' &&
          this.wk_Exist == 'No'

        ) {
         this.wk_Doublication_worrning =
          'هذا التوقيت محجوز لمريض اخر:<br><strong>' +
          data[i].patientname +
          '</strong>';

        this.MesgWarningDoublication();
        this.Submit_Temp();
          return;
        }
      }


      // =====================================
      // ✅ لو وصل هنا يبقى مفيش تعارض
      // =====================================
      const str1 = formatDate(this.resDate,'yyy-MM-dd','en') + 'T' + this.resTime + ':00.000Z';
      const str2 = formatDate(this.resDate,'yyy-MM-dd','en') + 'T' + this.resToTime + ':00.000Z';

      this.reservation.patientCode = this.patientCode;
      this.reservation.patientName = this.patientFName;
      this.reservation.resDate = formatDate(this.resDate, 'yyyy-MM-dd', 'en');

      this.reservation.resTime = str1;
      //this.reservation.resTime = newFrom.toISOString();
      this.reservation.resToTime = str2;

      // this.reservation.resToTime = newTo.toISOString();

      // حساب المدة
      const duration = newTo.getTime() - newFrom.getTime();
      const minutes = Math.floor(duration / (1000 * 60));
      this.reservation.resDuration = minutes.toString();

      this.reservation.resRoom = this.roomCode;
      this.reservation.resRoomDesc = this.roomName;
      this.reservation.resType = this.resType;
      this.reservation.resDoc = this.docCode;
      this.reservation.resDocName = this.docName;
      this.reservation.resStatus = this.resStatus;
      this.reservation.resNotes = this.resNotes;
      this.reservation.resPhone = this.resPhone;
      if(this.resonline ==''){this.resonline = 'On Site'};
      this.reservation.resonline = this.resonline;
      this.reservation.resconsultant = this.resconsultant;
      this.reservation.id = this.id;
      this.reservation.userID = this.storage.retrieve('stguserId');
      this.reservation.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.reservation.compCode = this.storage.retrieve('stgcompCode');
      console.log("DataSave:",this.reservation)

      this.resevationService.AddRese(this.reservation).subscribe(
        () => {
          this.mesgSave();
          this.retriveRes();
        },
        (error) => {
          alert(error);
        }
      );
    });
          });
}
Submit_Temp(){
debugger;
const dateStr = formatDate(this.reservationSelectedData.resDate, 'yyyy-MM-dd', 'en');
const timeStr = this.reservationSelectedData.resTime;

const dateTime = new Date(`${dateStr} ${timeStr}`);

// تعديل الوقت يدوياً قبل التحويل لـ ISO ليطابق التوقيت المحلي
const offset = dateTime.getTimezoneOffset() * 60000; // الفرق بالملي ثانية
const localISOTime = new Date(dateTime.getTime() - offset).toISOString().slice(0, -1);

this.reservation.resTime = localISOTime;
/////*********** */
const timeStr2 = this.reservationSelectedData.resToTime;

const dateTime2 = new Date(`${dateStr} ${timeStr2}`);

// تعديل الوقت يدوياً قبل التحويل لـ ISO ليطابق التوقيت المحلي
const offset2 = dateTime2.getTimezoneOffset() * 60000; // الفرق بالملي ثانية
const localISOTime2 = new Date(dateTime2.getTime() - offset2).toISOString().slice(0, -1);

this.reservation.resTime = localISOTime;

      const newFrom = new Date(this.reservationSelectedData.resDate + 'T' + this.reservationSelectedData.resTime);
      const newTo   = new Date(this.reservationSelectedData.resDate + 'T' + this.reservationSelectedData.resToTime);

      this.reservation.patientCode = this.reservationSelectedData.patientCode;
      this.reservation.patientName = this.reservationSelectedData.patientName;

      this.reservation.resDate = formatDate(this.reservationSelectedData.resDate, 'yyyy-MM-dd', 'en');


      // حساب المدة

        const date1 = new Date(this.resDate);
        const date2 = new Date(this.resDate);

        const diffMs = date2.getTime() - date1.getTime(); // الفرق بالميلي ثانية

        const diffMinutes = diffMs / (1000 * 60);
        const diffHours = diffMs / (1000 * 60 * 60);

      this.reservation.resDuration = diffHours.toString() + ':'+diffMinutes.toString();

      this.reservation.resRoom = this.reservationSelectedData.resRoom;
      this.reservation.resRoomDesc = this.reservationSelectedData.resRoomDesc;
      this.reservation.resType = this.reservationSelectedData.resType;
      this.reservation.resDoc = this.reservationSelectedData.resDoc;
      this.reservation.resDocName = this.reservationSelectedData.resDocName;
      this.reservation.resStatus = this.reservationSelectedData.resStatus;
      this.reservation.resNotes = this.reservationSelectedData.resNotes;
      this.reservation.resPhone = this.reservationSelectedData.resPhone;

      this.reservation.resonline = this.reservationSelectedData.resonline;
      this.reservation.resconsultant = this.reservationSelectedData.resconsultant;
      this.reservation.id = this.reservationSelectedData.id;
      this.reservation.userID = this.storage.retrieve('stguserId');
      this.reservation.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.reservation.compCode = this.storage.retrieve('stgcompCode');
      console.log("DataSave:",this.reservation)

      this.resevationService.AddRese(this.reservation).subscribe(
        () => {

          this.retriveRes();
        },
        (error) => {
          alert(error);
        }
      );
}
  SelectReservation(res: ReservationModel) {
    this.reservationSelectedData = res;
    this.reservationSelectedData.resRoom = res.resRoom;
    this.reservationSelectedData.resRoomDesc = res.resRoomDesc;
    this.reservationSelectedData.resDate = res.resDate;
    this.reservationSelectedData.resDate1 = res.resDate1;
    this.reservationSelectedData.resTime = res.resTime;
    this.reservationSelectedData.resToTime = res.resToTime;

    this.reservationSelectedData.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.reservationSelectedData.userID = this.storage.retrieve('stguserId');
    this.reservationSelectedData.resDuration = res.resDuration;

    this.patientCode = res.patientCode;
    this.RetrivePatientInsurance();
    this.patientFName = res.patientName;
    this.docCode = res.resDoc;
    this.reservationSelectedData.resRoomDesc = res.resDocName;
    this.RetriveDoctor();
    this.resTime   =  res.resTime1  ;
    this.resToTime = res.resToTime1 ;

    this.resType = res.resType;
    this.resNotes = res.resNotes;
    this.resStatus = res.resStatus;
    this.resPhone = res.resPhone;
    this.id = res.id;
    this.resconsultant = res.resconsultant;
    this.RetriveConsultant();
    this.resonline = res.resonline;
    this.userID = res.userID;
    this.wk_Exist = 'Yes';

    this.submitClicked.emit(this.reservationSelectedData);


  }

  ReportReservation() {
    this.route.navigate(['report-vewier', this.ReportURL0]);
  }
  ReportReservationD() {
    this.route.navigate(['report-vewier', this.ReportURL1]);
  }
  ReportReservationP() {
    this.route.navigate(['report-vewier', this.ReportURL2]);
  }
  mesgSave() {
    Swal({
      title: 'Your work has been saved',
      type: 'success',
      showConfirmButton: false,

      timer: 1500,
    });
  }
  MesgAuthorization() {
    Swal({
      type: 'warning',
      title: 'Oops...',
      text: 'Sorry .... You are not authorized !!',
      showConfirmButton: false,
      timer: 2000,
    });
  }
  openDialog_1(){
    this.screenTitle ='Reservation by doctor from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_Y-Butt_Y-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;
        this.docCode = result.docCode;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.docCode);



        this.route.navigate(['report-vewier', this.ReportURL1]);

      });
  }
  openDialog_2(){
    this.screenTitle ='Reservation by treatment room from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_Y'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;
        this.roomCode = result.docDepartment;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.roomCode);

        this.route.navigate(['report-vewier', this.ReportURL0]);

      });
  }
  openDialog_3(){
    this.screenTitle ='Reservation by patient from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_Y-Doc_N-Butt_N-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.patientFName ;
        this.toDate = result.birthDate;
        this.fromDateD = result.telHome;
        this.toDateD = result.patientFullName;
        this.PatientCode = result.patientCode;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.PatientCode);

        this.route.navigate(['report-vewier', this.ReportURL2]);

      });
  }
  OpenDialogPatientInsurance(){
     if(this.patientCode == '' || this.patientCode == null){
          return;
        }
        const dialogRef = this.dialogref.open(PatientIsuranceComponent,
          {
            data: {
              dataKey: this.patientsSelectedData,
              patientcode : this.patientCode,

            },
            width: '50vw',
          });
        dialogRef.afterClosed().subscribe(result => {
            this.RetrivePatient();
        //  this.retriveMortality();
        });

          const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {
            dialogSubmitSubscription.unsubscribe();
          });
  }
  RetriveCompany(){


     this.wk_Acc_Not = false;
      this.wk_Acc_Not1 = true;
          this.insurancecopmanyserive.getIsuranceCopmany(this.medcompany.toString()).subscribe((data: InsuranceCompanyModel) => {


      if (data) {
        // record found
             this.myimage = data.inslogo;
                  this.sellersPermitString =  data.inslogo;
                  this.myimage =this.sellersPermitString;
                  var kk = this.sellersPermitString;

                  this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);

                      this.wk_Acc_Not = true;
                      this.wk_Acc_Not1 = false;

      } else {
        // no record found
         this.wk_Acc_Not = false;
         this.wk_Acc_Not1 = true;
      }

    }, error => {
      // optional: also handle errors here
      console.error('Error fetching patient insurance:', error);
       this.wk_Acc_Not = false;
                      this.wk_Acc_Not1 = true; // maybe still run if error?
    });





  }
  RetrivePatientInsurance() {
  this.patientinsuranceservice.getPatientInsurance(this.patientCode).subscribe((data: PatientInsuranceModel | null) => {

      if (data) {
        // record found
        this.medcompany = data.medcompany;
        this.RetriveCompany();
      } else {
        // no record found
        this.medcompany = 0;
        this.RetriveCompany();
      }

    }, error => {
      // optional: also handle errors here
      console.error('Error fetching patient insurance:', error);
      this.RetriveCompany(); // maybe still run if error?
    });
  }
   MesgWarningDoublication() {
  Swal({
    type: 'warning',
    title: 'تنبيه' ,
    html: this.wk_Doublication_worrning,

    confirmButtonText: 'OK',
    confirmButtonColor: '#3085d6',

    allowOutsideClick: false,
    allowEscapeKey: false
  });
}

}
